// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import BootstrapVue from "bootstrap-vue";
import { scaleLinear } from "d3-scale";
import lodash from "lodash";
import VTooltip from "v-tooltip";
import VeeValidate from "vee-validate";
import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import VueFormWizard from "vue-form-wizard";
import VueI18n from "vue-i18n";
import VueLodash from "vue-lodash";
import VueResource from "vue-resource";
import VueSession from "vue-session";
import VueSweetAlert from "vue-sweetalert";
import VuejsDialog from "vuejs-dialog";
import Vuelidate from "vuelidate";
import messages from "../static/mocks/i18n";
import "./assets/css/global/custom.scss";
import { checkedDirective } from "./directives/checked";
import { globalsMixin } from "./mixins/globals";
import AccessUserPlugin from "./plugins/AccessUserPlugin";
import router from "./router";
import { store } from "./store/store";
import Fragment from "vue-fragment";
import Icons from "./icons";
import Trads from "./trads";
import { Context } from "plano_engine";
import ClientColorButton from "@/components/ui/ClientColorButton";
import cacheService from "@/services/cache";
import Axios from "axios";
import Globals from "@/components/globals";
import { VueMasonryPlugin } from "vue-masonry";
import Progress from "vue-multiple-progress";
import VueSecureHTML from "vue-html-secure";

// sends a log entry to a remote log aggregator, i.E. the back
let logError = async function(message) {
    try {
        const axios = Axios.create({
            baseURL: Globals.getBaseUrl()
        });
        let data = { message: message };
        let user = cacheService.getRem3rchUser();
        if (user) {
            data.token = user.token;
        }
        await axios.post("/front-logger", data);
    } catch (e) {
        console.log(e);
    }
};

// register global handler for unhandled errors
// when a error occurs outside a try..catch it will be handled in here
// different functions are needed to handle all types of errors
window.onerror = function(message) {
    logError(message);
};
window.addEventListener("error", function(e) {
    logError(e.message);
});
window.addEventListener("unhandledrejection", function(e) {
    logError(e.reason.message);
});

Vue.use(Fragment.Plugin);

Context.rescaleFactor = 0.5;

// override console.assert with one that throws if the assertion failed
// this make it much simpler to write error proof programs
const defaultAssert = console.assert;
console.assert = (assertion, msg, ...other) => {
    if (msg) defaultAssert(assertion, msg, ...other);
    else defaultAssert(assertion);
    if (!assertion) {
        throw new Error(msg || "Assertion Failed");
    }
};

Vue.use(VueSecureHTML);
Vue.use(BootstrapVue);
Vue.use(VueSweetAlert);
Vue.use(AccessUserPlugin);
Vue.use(VueSession);
Vue.use(VuejsDialog);
Vue.use(VTooltip);
Vue.use(VeeValidate, { fieldsBagName: "formFields" });
Vue.use(Icons);
Vue.use(Trads);

Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.use(VueI18n);
Vue.use(VueAwesomeSwiper);
Vue.use(VueLodash, lodash);
Vue.use(scaleLinear);
Vue.use(Vuelidate);
Vue.use(VueFormWizard);
Vue.use(VueMasonryPlugin);
Vue.use(Progress);

Vue.mixin(globalsMixin);
Vue.directive("checked", checkedDirective);

// A custom component to allow using `<style></style>` within vue templates
// this is useful to temporarily add global styling
Vue.component("v-style", {
    render: function(createElement) {
        return createElement("style", this.$slots.default);
    }
});

Vue.component("ClientColorButton", ClientColorButton);

Vue.filter("CurrencyCustomPipe", function(value, codeIso = "fr-FR", currency = "EUR") {
    return value.toLocaleString(codeIso, {
        style: "currency",
        currency: currency
    });
});
Vue.filter("lowercase", function(value) {
    return value.toLowerCase();
});

Vue.filter("capitalize", function(value) {
    if (typeof value !== "string") return "";
    return value.charAt(0).toUpperCase() + value.slice(1);
});

export const i18n = new VueI18n({
    locale: cacheService.getUserLang(),
    messages
});

export const bus = new Vue();

/* eslint-disable no-new */
let vm = new Vue({
    // eslint-disable-line no-unused-vars
    el: "#app",
    router,
    template: "<router-view />",
    store,
    i18n
});



// WEBPACK FOOTER //
// ./src/main.js